import { openModal } from '@/features/ui/uiModalSlice';
import { store } from '@/store/store';
import axios from 'axios';

export function showApiSuccess(title = '成功', message = '') {
  store.dispatch(openModal({ variant: 'success', title, message }));
}

export function parseApiError(err: unknown, fallback = '發生錯誤，請稍後重試'): string {
  if (axios.isAxiosError(err)) {
    return err.response?.data?.message ?? fallback;
  }

  if (err instanceof Error) {
    return err.message || fallback;
  }

  return fallback;
}

export function showApiError(err: unknown, title = '錯誤') {
  const message = parseApiError(err);
  store.dispatch(openModal({ variant: 'error', title, message }));
}
